export const sumFormFormatter = (value: string) => {
  let formattedValue = value
    .replace(/[^\d,.]/g, '')
    .replace(/\./g, ',')
    .replace(/,+/g, ',')
    .replace(/^0+(?=\d)/, '')

  const parts = formattedValue.split(',')
  if (parts.length > 1) {
    formattedValue = `${parts.shift()},${parts.join('')}`
  }

  return formattedValue
}

export const sumSubmitFormatter = (value: string | number | null | undefined) =>
  sumFormFormatter(String(value ?? '')).replace(',', '.')
